export const sites = {
  Add_new_site: "Adicionar novo site",
  Address: "Endereço",
  Address_1: "Endereço 1",
  Address_2: "Endereço 2",
  All_sites: "Todos os sites",
  Applicability: "Aplicabilidade",
  Basic_information: "Informações básicas",
  City: "Cidade",
  "Country_*": "País *",
  Create_assessment: "Criar avaliação",
  Create_new_site: "Criar novo site",
  edit: "Editar",
  Edit_site_details: "Editar detalhes do site",
  upload_your_templates: "Enviar modelos de site preenchidos",
  Here_you_can_manage_all_sites_in_your_organization: "Aqui você pode gerenciar todos os sites em sua organização",
  "Name_*": "Nome *",
  Postcode: "CEP",
  Release_to_drop_the_files_here: "Solte para liberar os arquivos aqui",
  "Relevant_standard_*": "Padrão relevante *",
  Save_site: "Salvar site",
  "Scope_of_applicability_*": "Escopo de aplicabilidade *",
  "Site_coordinator_*": "Coordenador do site *",
  siteCoordinator: "Coordenador do Site",
  siteName: "Nome do Site",
  Standard_Body: "Órgão do Padrão",
  Standards: "Padrões",
  State: "Estado",
  Template: "Modelo",
  create_site_from_template: "Criar um site a partir de um arquivo de modelo",
  You_can_upload_many_sites_in_the_same_file: "Você pode enviar vários sites no mesmo arquivo",
} as const;
